import { Injectable, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { QuoteSelector } from '@nibtravel/shared/data-access/quote';
import { DomService } from '@nibtravel/shared/util/dom';
import {
  BaseGtmProvider,
  GtmPage,
  IGtmProvider,
  VirtualPathMap,
} from '@nibtravel/shared/util/gtm';

@Injectable({ providedIn: 'root' })
export class PublicGtmProvider extends BaseGtmProvider implements IGtmProvider {
  constructor(
    service: DomService,
    router: Router,
    factory: RendererFactory2,
    private store: Store
  ) {
    super(service, router, factory);
  }

  urlTracker = (event: NavigationEnd) => {
    return event.urlAfterRedirects === '/' || event.urlAfterRedirects === ''
      ? GtmPage.HomePage
      : event.urlAfterRedirects;
  };

  virtualTracker = (event: NavigationEnd) => {
    return VirtualPathMap.get(event.urlAfterRedirects);
  };

  campaignTrackers = () =>
    this.store.selectSnapshot(QuoteSelector.analyticsParams);
}
